export default "__VITE_ASSET__sYqRFv0o__"